import { Row, Col, Form, Button } from 'react-bootstrap';
import { Search, Download, X } from 'lucide-react';

const DataTableToolbar = ({
    searchValue = '',
    onSearchChange,
    searchPlaceholder = 'Search…',
    filters = [],
    onExport,
    children,
}) => {
    return (
        <div className="data-table-toolbar mb-3">
            <Row className="g-2 align-items-end">
                {onSearchChange && (
                    <Col xs={12} md={4} lg={3}>
                        <div className="position-relative">
                            <Search size={16} className="position-absolute top-50 translate-middle-y ms-2 text-muted" />
                            <Form.Control
                                size="sm"
                                type="text"
                                placeholder={searchPlaceholder}
                                value={searchValue}
                                onChange={(e) => onSearchChange(e.target.value)}
                                className="ps-4"
                            />
                            {searchValue && (
                                <button
                                    type="button"
                                    className="btn btn-link p-0 position-absolute top-50 translate-middle-y end-0 me-2 text-muted"
                                    onClick={() => onSearchChange('')}
                                >
                                    <X size={14} />
                                </button>
                            )}
                        </div>
                    </Col>
                )}

                {filters.map((filter, idx) => (
                    <Col xs={6} md={3} lg={2} key={idx}>
                        <Form.Select
                            size="sm"
                            value={filter.value}
                            onChange={(e) => filter.onChange(e.target.value)}
                        >
                            <option value="">{filter.placeholder || 'All'}</option>
                            {filter.options.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>
                ))}

                {children}

                {onExport && (
                    <Col xs="auto" className="ms-auto">
                        <Button size="sm" variant="outline-secondary" onClick={onExport}>
                            <Download size={14} className="me-1" /> Export CSV
                        </Button>
                    </Col>
                )}
            </Row>
        </div>
    );
};

export default DataTableToolbar;
